module.exports = __webpack_public_path__ + "static/media/pin_organico.ce3988e3.svg";